import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IDashboardComponent, IDashboardState } from './types';

const initialState: IDashboardState = {
    dashboards: [],
    isFixedHeader: false,
    isOpenFixedHeader: false,
};

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: initialState,
    reducers: {
        /**
         * Устанавливает массив компонентов дашборда
         */
        setDashboards: (state, action: PayloadAction<IDashboardComponent[]>) => {
            state.dashboards = action.payload;
        },
        /**
         * Устанавливает флаг фиксированного заголовка
         */
        setIsFixedHeader: (state, action: PayloadAction<boolean>) => {
            state.isFixedHeader = action.payload;
        },
        /**
         * Устанавливает флаг открытого фиксированного заголовка
         */
        setIsOpenFixedHeader: (state, action: PayloadAction<boolean>) => {
            state.isOpenFixedHeader = action.payload;
        },
    },
});

export const dashboardSliceReducer = dashboardSlice.reducer;
export const dashboardSliceActions = dashboardSlice.actions;
